//export const BASE_API = 'https://gestion.comcolors.com/api/v1';
//export const QUESTIONNAIRE_API = 'https://m.comcolors.com/api/v1';

export const BASE_API = process.env.BASE_API;
export const QUESTIONNAIRE_API = process.env.QUESTIONNAIRE_API;


// WEBPACK FOOTER //
// ./src/helpers/base.js